import { render } from "./SeoBulkModal.vue?vue&type=template&id=c152091c&scoped=true"
import script from "./SeoBulkModal.vue?vue&type=script&lang=js"
export * from "./SeoBulkModal.vue?vue&type=script&lang=js"

import "./SeoBulkModal.vue?vue&type=style&index=0&id=c152091c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c152091c"]])

export default __exports__